import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'

const initState = {
  listView: {
    list: [],
    total: 0,
    page: 1,
    limit: 20,
    filters: {
      searchStr: '',
      period: [null, null],
      product: null,
      pricelistKind: null,
    },
    sort: { sortBy: null, sortDesc: false },
  },
  objectViews: [],
}

export const state = Object.assign({}, _.cloneDeep(initState))

export const mutations = {
  setListViewProperty(state: any, payload: any) {
    Object.keys(payload).forEach((key) => {
      state.listView[key] = payload[key]
    })
  },

  setFilters(state: any, filter: any) {
    Object.keys(filter).forEach((key) => {
      state.listView.filters[key] = filter[key]
    })
  },

  setSort(state: any, sort: any) {
    Object.keys(sort).forEach((key) => {
      state.listView.sort[key] = sort[key]
    })
  },

  addObjectView(state: any, view: any) {
    const existView = state.objectViews.find((el: any) => el.viewId === view.viewId)

    if (existView === undefined) {
      state.objectViews.push(view)
    }
  },

  setObjectViewProperty(state: any, payload: any) {
    const index = state.objectViews.findIndex((el: any) => el.viewId === payload.viewId)
    if (index > -1) {
      state.objectViews[index][payload.property] = payload.value
    }
  },

  setObjectProperty(state: any, payload: any) {
    const index = state.objectViews.findIndex((el: any) => el.viewId === payload.viewId)
    if (index > -1) {
      state.objectViews[index].object[payload.property] = payload.value
    }
  },

  delObjectView(state: any, viewId: any) {
    for (const [i, v] of state.objectViews.entries()) {
      if (v.viewId === viewId) {
        state.objectViews.splice(i, 1)
        break
      }
    }
  },

  resetState(state: any) {
    Object.assign(state, _.cloneDeep(initState))
  },
}

export const actions = {
  async findAll({ commit }: any, payload: any) {
    const list: any = []

    return axios
      .get(`/pricelist`, payload)
      .then((response) => {
        if (response.status === 200) {
          const result = response.data

          let list = []
          if (result.rows) {
            list = result.rows
          } else {
            list = result
          }

          list.forEach((el: any) => {
            el.createdAt = moment(el.createdAt).format('DD.MM.YYYY HH:mm:ss')
            el.date = moment(el.date).format('DD.MM.YYYY hh:mm:ss')
            if (!el.beginDate) {
              el.beginDate = ''
            } else {
              el.beginDate = moment(el.beginDate).format('DD.MM.YYYY')
            }

            if (!el.endDate) {
              el.endDate = ''
            } else {
              el.endDate = moment(el.endDate).format('DD.MM.YYYY')
            }

            el.presentation = `Cennik nr ${el.number} od ${el.createdAt}`
          })

          const total = result.count ? result.count : list.length
          let page = state.listView.page

          if (total > 0) {
            const pages = Math.ceil(total / state.listView.limit)
            if (pages < state.listView.page) {
              page = pages
            }
          } else {
            page = 1
          }

          if (!payload.noCommit) {
            commit('setListViewProperty', { list, total, page })
          }
        } else {
          if (!payload.noCommit) {
            commit('setListViewProperty', { list, total: list.length, page: 1 })
          }
        }

        return response
      })
      .catch((error) => {
        console.error(error)
        if (!payload.noCommit) {
          commit('setListViewProperty', { list, total: list.length, page: 1 })
        }
        return error
      })
  },

  async findByPk({ commit }: any, payload: any) {
    if (state.objectViews.some((v: any) => v.viewId === payload.params.id)) return

    return axios
      .get(`/pricelist/${payload.params.id}`, payload.query)
      .then((response) => {
        const object = response.data
        object.createdAt = moment(object.createdAt).format('DD.MM.YYYY hh:mm:ss')
        object.date = moment(object.date).format('DD.MM.YYYY hh:mm:ss')
        if (!object.beginDate) {
          object.beginDate = ''
        } else {
          object.beginDate = moment(object.beginDate).format('DD.MM.YYYY')
        }

        if (!object.endDate) {
          object.endDate = ''
        } else {
          object.endDate = moment(object.endDate).format('DD.MM.YYYY')
        }

        commit('addObjectView', { viewId: payload.params.id, object, tabIndex: 0 })
        return response
      })
      .catch((error) => {
        console.error(error)
        return error
      })
  },

  async update({ commit }: any, payload: any) {
    return axios
      .put(`/pricelist/${payload.id}`, payload)
      .then((response) => {
        return response
      })
      .catch((error) => {
        console.error(error)
        return error
      })
  },

  resetState({ commit }: any) {
    commit('resetState')
  },
}

export const getters = {
  listView(state: any) {
    return state.listView
  },

  objectView: (state: any) => (viewId: any) => {
    return state.objectViews.find((el: any) => el.viewId === viewId)
  },

  presentation: (state: any) => (viewId: any) => {
    const objectView = state.objectViews.find((el: any) => el.viewId === viewId)

    let presentation = ''
    if (objectView) {
      presentation = objectView.object.priceCode
    }

    return presentation
  },

  customerList(state: any) {
    return state.listView.list
  },
}
